(() => {
  const root = document.documentElement;
  const meta = document.querySelector('meta[name="theme-color"]');
  const toggles = document.querySelectorAll('[data-monti-theme-toggle]');
  if (!toggles.length) return;

  const themeColors = { light: '#faf8f5', dark: '#18202a' };

  const apply = (theme) => {
    root.dataset.theme = theme;
    if (meta) meta.setAttribute('content', themeColors[theme]);
    toggles.forEach((toggle) => {
      toggle.setAttribute('aria-label', theme === 'dark' ? toggle.dataset.labelLight : toggle.dataset.labelDark);
    });
  };

  apply(root.dataset.theme === 'dark' ? 'dark' : 'light');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const next = root.dataset.theme === 'dark' ? 'light' : 'dark';
      apply(next);
      try {
        localStorage.setItem('monti-theme', next);
      } catch (e) {}
    });
  });
})();
